/**
 * 维修无忧
 */
import { SubsidyApply } from '../types';

export default {
    name: `${SubsidyApply}`,
    path: '/subsidyApply',
    component: () => import(/* webpackChunkName: 'subsidyApply' */ '@/views/subsidyApply/'),
    redirect: { name: `${SubsidyApply}Index` },
    meta: {
        title: '补贴申请',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${SubsidyApply}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'subsidyApply' */ '@/views/subsidyApply/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        {
            name: 'Detail',
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'subsidyApplyDetail' */ '@/views/subsidyApply/detail/Detail.vue'),
        },
    ],
};
